import type { FunctionComponent } from "react";
import { useMemo } from "react";

import HorizontalStats from "~/components/HorizontalStats";
import OverflowPercentageChart from "~/components/OverflowPercentageChart";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";


type Props = {
	budgetCentsPlanned: number;
	budgetCentsTracked: number;
};

const QuotaBudgetStats: FunctionComponent<Props> = ({
	budgetCentsPlanned,
	budgetCentsTracked,
}) => {
	const percentageTracked = (budgetCentsTracked / budgetCentsPlanned) * 100;

	const budgetCentsPlannedFormatted = formatCentsToCurrency(budgetCentsPlanned);
	const budgetCentsTrackedFormatted = formatCentsToCurrency(budgetCentsTracked);
	const restFormatted = formatCentsToCurrency(budgetCentsPlanned - budgetCentsTracked);
	const percentageTrackedFormatted = percentageTracked === Infinity ? "n/a" : percentageTracked.toFixed(0) + "%";

	const stats = useMemo(() => {

		return [
			{
				label: "Budget",
				value: budgetCentsPlannedFormatted,
			},
			{
				label: "Verfügt",
				value: budgetCentsTrackedFormatted,
			},
			{
				label: "Rest",
				value: restFormatted,
				isHighlighted: budgetCentsPlanned - budgetCentsTracked < 0,
			}];
	}, [budgetCentsPlanned, budgetCentsPlannedFormatted, budgetCentsTracked, budgetCentsTrackedFormatted, restFormatted]);


	return (
		<HorizontalStats stats={stats}>
			<OverflowPercentageChart percentage={percentageTracked === Infinity ? 0 : percentageTracked}
									 size={80}
									 thickness={0.4}>
				<div className="text-center text-sm font-bold">
					{percentageTrackedFormatted}
				</div>
			</OverflowPercentageChart>
		</HorizontalStats>
	);
};

export default QuotaBudgetStats;